let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("h3JUd")).then(() => parcelRequire('ef83l'));